module.exports = __webpack_public_path__ + "static/media/zhuanglin.6d67eb48.jpg";